export default __webpack_public_path__ + "static/media/dr_logo.2728c8ae.png";